import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "link-picker btn-group btn-group-sm w-auto mb-3",
  role: "group",
  "aria-label": "Link type"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-url col-12 mb-3"
}
const _hoisted_4 = {
  key: 0,
  class: "url-selector mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "link", -1)
const _hoisted_6 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "url-input" }
const _hoisted_8 = {
  key: 1,
  class: "col-page-link col-12 mb-4"
}
const _hoisted_9 = { class: "selector d-flex align-items-center" }
const _hoisted_10 = { class: "page-selector d-flex align-items-center me-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "article", -1)
const _hoisted_12 = { class: "linked-page-name d-flex align-items-center" }
const _hoisted_13 = { class: "d-flex justify-content-center align-items-center border border-1 rounded fst-italic px-3 py-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "preview"
}
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center text-danger mt-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "error", -1)
const _hoisted_19 = {
  key: 1,
  class: "d-flex align-items-center text-warning mt-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "warning", -1)
const _hoisted_21 = { class: "card-title" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "card-text fst-italic" }
const _hoisted_24 = {
  key: 2,
  class: "col-target col-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_CpAbstractsOverview = _resolveComponent("CpAbstractsOverview")!
  const _component_base_card_image = _resolveComponent("base-card-image")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.enableNoLink)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLinkType(_ctx.PageLinkTypeEnum.NONE))),
            class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isPageLinkType(_ctx.PageLinkTypeEnum.NONE)}]),
            type: "button"
          }, _toDisplayString(_ctx.$t('noLink')), 3))
        : _createCommentVNode("", true),
      (_ctx.enableUrl)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLinkType(_ctx.PageLinkTypeEnum.URL))),
            class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isPageLinkType(_ctx.PageLinkTypeEnum.URL)}]),
            type: "button"
          }, _toDisplayString(_ctx.$t('url')), 3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLinkType(_ctx.PageLinkTypeEnum.PAGE))),
        class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isPageLinkType(_ctx.PageLinkTypeEnum.PAGE)}]),
        type: "button"
      }, _toDisplayString(_ctx.$t('page')), 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.enableUrl && _ctx.isPageLinkType(_ctx.PageLinkTypeEnum.URL))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.enableSelectUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_base_modal_button, {
                    class: "btn btn-icon btn-sm btn-warning",
                    "modal-id": _ctx.modalId + 'url'
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createTextVNode(_toDisplayString(_ctx.$t('selectStandardPage')), 1)
                    ]),
                    _: 1
                  }, 8, ["modal-id"]),
                  _createVNode(_component_base_modal, {
                    "modal-id": _ctx.modalId + 'url',
                    "dialog-classes": "modal-sm",
                    title: _ctx.$t('selectStandardPage')
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_base_modal_button, {
                          mode: "close",
                          class: "btn btn-outline-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_base_modal_button, {
                          onClick: _ctx.setRelativeUrl,
                          mode: "close",
                          class: "btn btn-primary ms-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('select')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_input_select, {
                        modelValue: _ctx.selectedRelativeUrlOption,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRelativeUrlOption) = $event)),
                        name: "relativeUrls",
                        selectText: _ctx.$t('selectText'),
                        options: _ctx.relativeUrlsOptions,
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "selectText", "options", "errors"])
                    ]),
                    _: 1
                  }, 8, ["modal-id", "title"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_input_text, {
                modelValue: _ctx.internalPayload.external_url,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalPayload.external_url) = $event)),
                label: _ctx.$t('url'),
                name: 'url-' + _ctx.uuid,
                rules: "required",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "label", "name", "errors"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPageLinkType(_ctx.PageLinkTypeEnum.PAGE))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_base_modal_button, {
                  class: "btn btn-icon btn-sm btn-warning",
                  "modal-id": _ctx.modalId + 'page'
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(_ctx.$t('select') + ' ' + _ctx.$t('page').toLowerCase()), 1)
                  ]),
                  _: 1
                }, 8, ["modal-id"]),
                _createVNode(_component_base_modal, {
                  "modal-id": _ctx.modalId + 'page',
                  "dialog-classes": "modal-xl modal-dialog-scrollable",
                  title: _ctx.$t('contentPages')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CpAbstractsOverview, {
                      "enable-alt-lang-pages": _ctx.enableAltLangPages,
                      onExceptions: _ctx.setExceptions,
                      onSelectedCp: _ctx.setPageId
                    }, null, 8, ["enable-alt-lang-pages", "onExceptions", "onSelectedCp"])
                  ]),
                  _: 1
                }, 8, ["modal-id", "title"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.linkedContentPage?.name ?? _ctx.$t('noPageSelected')), 1),
                (_ctx.internalPayload.page_id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearPageId && _ctx.clearPageId(...args)), ["prevent"])),
                      class: "btn btn-icon btn-sm ms-1"
                    }, _hoisted_15))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.linkedContentPage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.linkedContentPage.is_page_deleted)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(_ctx.$t('linkedPageDeleted')), 1)
                      ]))
                    : (_ctx.linkedContentPage.status_code === 'NOT_PUBLISHED')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(_toDisplayString(_ctx.$t('linkedPageNotPublished')), 1)
                        ]))
                      : _createCommentVNode("", true),
                  _createVNode(_component_base_card, { class: "flex-row align-items-start mt-3" }, {
                    default: _withCtx(() => [
                      (_ctx.linkedContentPage)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.linkedContentPage?.overview_cb?.image_url)
                              ? (_openBlock(), _createBlock(_component_base_card_image, {
                                  key: 0,
                                  src: _ctx.linkedContentPage.overview_cb.image_url,
                                  style: {"padding":"1rem 0 1rem 1rem","height":"auto","max-width":"calc(30% - 1rem)"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_base_card_body, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.linkedContentPage.overview_cb.title ?? _ctx.linkedContentPage.name), 1),
                                (_ctx.linkedContentPage.overview_cb.content)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      innerHTML: _ctx.linkedContentPage.overview_cb.content,
                                      class: "card-text"
                                    }, null, 8, _hoisted_22))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.linkedContentPage)
                        ? (_openBlock(), _createBlock(_component_base_card_body, { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('noPreview')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.enableTarget && !_ctx.isPageLinkType(_ctx.PageLinkTypeEnum.NONE))
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_input_select, {
              modelValue: _ctx.internalPayload.target,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalPayload.target) = $event)),
              options: _ctx.extLinkOptions,
              name: 'target-' + _ctx.uuid,
              label: _ctx.$t('targetWindow'),
              selectText: _ctx.$t('selectText'),
              errors: _ctx.errors
            }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}